import axios from "axios";
import ConstantList from "../appConfig";
import { getFormData } from "app/common/LocalFunction";

const API_PATH = ConstantList.API_EN_POINT + "/emr-organization";
const API_PATH_2 = ConstantList.API_EN_POINT + "/organization";

export const pagingOrganization = (SearchObject) =>
  axios.post(`${API_PATH}/search-by-page`, SearchObject);

export const getOrganizationById = (organizationId) =>
  axios.get(`${API_PATH}/get-by-id/${organizationId}`);

export const saveOrUpdateOrganization = (organization) =>
  axios.post(`${API_PATH}/save-or-update`, organization);

export const deleteOrganization = (organizationId) =>
  axios.delete(`${API_PATH}/mark-delete/${organizationId}`);

export const findByCode = (organizationId) =>
  axios.get(`${API_PATH}/find-by-code/${organizationId}`);

export const saveOrUpdateOrganizationCore = (organization) =>
  axios.post(`${API_PATH_2}`, organization);

export const getOrganizationCore = (organizationId) =>
  axios.get(`${API_PATH_2}/${organizationId}`);

export const pagingOrganizationCore = (pageIndex, pageSize) =>
  axios.get(`${API_PATH_2}/${pageIndex}/${pageSize}`);

export const deleteOrganizationCore = (organizationId) =>
  axios.delete(`${API_PATH_2}/${organizationId}`);

export const syncOrganization = () =>
    axios.post(API_PATH + "/sync-organization-from-crm", {},{
        headers: {
            "Content-Type": "application/json"
        }
    });